import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1952da6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.src)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['rounded p-0 card-image placeholder bg-black', _ctx.classes])
      }, null, 2))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _ctx.src,
        class: _normalizeClass(['rounded p-0 card-image', _ctx.classes]),
        alt: "Card"
      }, null, 10, _hoisted_1))
}